import React from 'react';

const CarAdquisiciones = ({ item }) => {
    // const urlImg = 'http://biblioteca.esen.edu.sv/';
    return (
        <div className="esen-resource-grid">
            {
                item.map((elemento, i) => {
                    return (
                        <div className="card esen-resource" key={`${elemento.titulos}-${i}`}>
                            <div className="card-body text-center">
                                {/* <img className="rounded mx-auto d-block" alt={elemento.idt4} src={urlImg + elemento.portada} /> */}
                                <span className="display-4 text-muted" aria-hidden="true">
                                    <i className="fa fa-book"></i>
                                </span>
                                <h3 className="h6 mt-3 mb-1">{elemento.titulos}</h3>
                                <p className="text-muted mb-0">{elemento.autores}</p>
                            </div>
                        </div>
                    )
                })
            }
        </div>

    )
}

export default CarAdquisiciones;
